import { useFetch } from '../../../hooks/use-fetch';
import { errorNotification } from '../../../providers/mantine-notifications';
import { PermissionAlias } from '../../../utils/enums';
import {
  UseGetPermissionsByUserProps,
  UseGetUserPermissionsByIdProps,
  UseGetUserPermissionsProps,
  UseSetUserPermissionsProps,
} from '../../../utils/types/data/hooks/permissions';
import {
  getPermissionsByUserRequest,
  getUserPermissionsByIdRequest,
  getUserPermissionsRequest,
  setUserPermissionsRequest,
} from '../../services/permissions';

export function useGetPermissionsByUser() {
  const {
    fetchData,
    state: { data: reponse, error, loading },
  } = useFetch<PermissionAlias[]>();

  const fetch = ({ onSuccess }: UseGetPermissionsByUserProps) =>
    fetchData({
      fetcher: () => getPermissionsByUserRequest(),
      onError: () => {
        errorNotification({
          title: 'Erro ao buscar permissões.',
          message: 'tente novamente.',
        });
      },
      onSuccess,
    });

  return {
    fetch,
    reponse,
    error,
    loading,
  };
}

export function useGetUserPermissions() {
  const {
    fetchData,
    state: { data: reponse, error, loading },
  } = useFetch<PermissionAlias[]>();

  const fetch = ({ onSuccess }: UseGetUserPermissionsProps) =>
    fetchData({
      fetcher: () => getUserPermissionsRequest(),
      onError: () => {
        errorNotification({
          title: 'Erro ao buscar permissões do usuário.',
          message: 'tente novamente.',
        });
      },
      onSuccess,
    });

  return {
    fetch,
    reponse,
    error,
    loading,
  };
}

export function useGetUserPermissionsById() {
  const {
    fetchData,
    state: { data: reponse, error, loading },
  } = useFetch<PermissionAlias[]>();

  const fetch = ({ userId, onSuccess }: UseGetUserPermissionsByIdProps) =>
    fetchData({
      fetcher: () => getUserPermissionsByIdRequest(userId),
      onError: () => {
        errorNotification({
          title: 'Erro ao buscar permissões do usuário.',
          message: 'tente novamente.',
        });
      },
      onSuccess,
    });

  return {
    fetch,
    reponse,
    error,
    loading,
  };
}

export function useSetUserPermissions() {
  const {
    fetchData,
    state: { data: reponse, error, loading },
  } = useFetch<void>();

  const fetch = ({
    userId,
    permissions,
    onSuccess,
  }: UseSetUserPermissionsProps) =>
    fetchData({
      fetcher: () => setUserPermissionsRequest(userId, permissions),
      onError: () => {
        errorNotification({
          title: 'Erro ao salvar permissões do usuário.',
          message: 'tente novamente.',
        });
      },
      onSuccess,
    });

  return {
    fetch,
    reponse,
    error,
    loading,
  };
}
